import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { useHtmlClassService } from "../../_core/MetronicLayout";

export function Aside() {
  const uiService = useHtmlClassService();
  const { payment_info } = require("react-redux").useSelector(
    (state) => state.myaccount || {},
  );
  const layoutProps = useMemo(() => {
    return {
      disableScroll:
        objectPath.get(uiService.config, "aside.menu.dropdown") === "true" ||
        false,
      asideClassesFromConfig: uiService.getClasses("aside", true),
      disableAsideSelfDisplay:
        objectPath.get(uiService.config, "aside.self.display") === false,
      headerLogo: uiService.getLogo()
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Aside */}
      <div id="kt_aside"
        className={`aside aside-left  ${layoutProps.asideClassesFromConfig} d-flex flex-column flex-row-auto`}>


        {/* begin::Aside Menu */}
        <div id="kt_aside_menu_wrapper" className="aside-menu-wrapper flex-column-fluid">

          <div className="user-welcome">
            <span className="welcome-text">
              <b>Welcome back,<br />{payment_info?.shop_name || "Bela's Boutique"}</b>
            </span>
            <span className="plan-text">
              Plan: {payment_info?.name || "Annual Member"}
              {payment_info?.price == 0 && payment_info.name == 'Free Plan' ? "" : <i className="fa-solid fa-star plan-star"></i>}
            </span>
          </div>

          {layoutProps.disableAsideSelfDisplay && (
            <>

              {/* <div className="header-logo">
                  <Link to="">
                    <img alt="logo" src={layoutProps.headerLogo}/>
                  </Link>
                </div> */}

            </>
          )}
          <AsideMenu disableScroll={layoutProps.disableScroll} />
        </div>

        {/* end::Aside Menu */}
      </div>
      {/* end::Aside */}
    </>
  );
}
